import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Schedule from "./pages/Schedule";
import Facilities from "./pages/Facilities";
import Users from "./pages/Users";
import Layout from "./components/Layout";
import Auth from "./pages/auth/Auth";
import LoginCallback from "./pages/auth/LoginCallback";
import { AuthProvider, AuthContext } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { getDefaultPage } from "./constants/roleConfig";
import Calendar from "./pages/Calendar";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import AgentFiles from "./pages/AgentFiles";
import Workflows from "./pages/Workflows";
import Settings from "./pages/Settings";

const RoleBasedRedirect = () => {
    const { user } = useContext(AuthContext);
    const defaultPage = getDefaultPage(user?.activeRole);
    return <Navigate to={defaultPage} replace />;
};

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Auth />} />
                    <Route path="/login/callback" element={<LoginCallback />} />
                    <Route path="/schedule" element={<ProtectedRoute allowedRoles={['Provider']}><Layout><Schedule /></Layout></ProtectedRoute>} />
                    <Route path="/facilities" element={<ProtectedRoute allowedRoles={['Manager', 'Observer']}><Layout><Facilities /></Layout></ProtectedRoute>} />
                    <Route path="/users" element={<ProtectedRoute allowedRoles={['Manager']}><Layout><Users /></Layout></ProtectedRoute>} />
                    <Route path="/agent-files" element={<ProtectedRoute allowedRoles={['Manager', 'Observer']}><Layout><AgentFiles /></Layout></ProtectedRoute>} />
                    <Route path="/workflows" element={<Navigate to="/agent-files?tab=workflows" replace />} />
                    <Route path="/workflows/:workflowId" element={<ProtectedRoute allowedRoles={['Manager', 'Observer']}><Layout><Workflows /></Layout></ProtectedRoute>} />
                    <Route path="/calendar" element={<ProtectedRoute allowedRoles={['Manager', 'Provider', 'Observer']}><Layout><Calendar /></Layout></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
                    <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
                    <Route path="/" element={<ProtectedRoute><RoleBasedRedirect /></ProtectedRoute>} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;
